<app-header></app-header>

<section class="hero"
  role="banner"
  aria-label="Free live ICF coaching sessions — NEXGEN Executive Coaching Academy"
  itemscope
  itemtype="https://schema.org/WebPageElement">
  <div class="hero-bg"></div>
  <div class="hero-grid"></div>
  <div class="gold-bar-left"></div>
  <div class="hero-sweep"></div>

  <div class="container">
    <div class="hero-inner reveal" [class.visible]="revealHero">

      <div class="hero-eyebrow-wrap">
        <span class="hero-eyebrow-line"></span>
        <span class="hero-eyebrow-text" itemprop="name">{{ pageContent?.hero?.eyebrow }}</span>
        <span class="hero-eyebrow-line"></span>
      </div>

      <h1 itemprop="headline">
        <ng-container *ngFor="let line of heroHeadlineLines; let i = index">
          {{ line.before }}
          <ng-container *ngIf="line.em"><em>{{ line.em }}</em></ng-container>
          <ng-container *ngIf="line.after"> {{ line.after }}</ng-container>
          <br *ngIf="i !== heroHeadlineLines.length - 1" />
        </ng-container>
      </h1>

      <p class="hero-para">
        <span [innerHTML]="nl2br(pageContent?.hero?.paragraph)"></span>
      </p>

      <div class="hero-cta">
        <button class="btn btn-gold" type="button" (click)="nextSession && openPopup(nextSession)"
          [disabled]="!nextSession">
          {{ pageContent?.finalCta?.primaryBtnText }}
        </button>
        <span class="hero-cta-note">{{ pageContent?.miscTexts?.heroStrongText }}</span>
      </div>

      <div class="hero-stats">
        <div class="hstat">
          <div class="hn">Free</div>
          <div class="hl">to attend — no credit card</div>
        </div>
        <div class="hstat-sep"></div>
        <div class="hstat">
          <div class="hn">Live</div>
          <div class="hl">Q&A with faculty</div>
        </div>
        <div class="hstat-sep"></div>
        <div class="hstat">
          <div class="hn">60</div>
          <div class="hl">minutes</div>
        </div>
      </div>

    </div>
  </div>
</section>

<div class="next-session-band"
  *ngIf="nextSession"
  aria-label="Next upcoming session details and countdown">
  <!-- <div class="container"> -->
  <div class="next-session-inner reveal reveal-delay-1" [class.visible]="revealNext" [ngStyle]="mergeStyles(
        ngLayoutStyle(pageContent?.nextBand?.layoutStyle),
        ngBoxStyle(pageContent?.nextBand?.nextSessionCardStyle)
      )">
    <div>
      <div class="next-label" [ngStyle]="ngTextStyle(pageContent?.nextBand?.labelStyle)">
        {{ pageContent?.nextBand?.labelText }}
      </div>

      <div class="next-headline" [ngStyle]="ngTextStyle(pageContent?.nextBand?.headlineStyle)">
        {{ nextSession.title }}
        <!-- <em [ngStyle]="ngTextStyle(pageContent?.nextBand?.headlineEmphasisStyle)">
            {{ pageContent?.sessionsSection?.nextSessionSubtitle }}
          </em> -->
      </div>

      <div class="next-meta" [ngStyle]="ngTextStyle(pageContent?.nextBand?.metaStyle)">
        {{ formatDateEST(nextSession.sessions?.[0]?.date) }}
        &nbsp;·&nbsp;
        {{ formatTimeToEST(nextSession.sessions?.[0]?.startTime || '') }} -
        {{ formatTimeToEST(nextSession.sessions?.[0]?.endTime || '') }}
        &nbsp;·&nbsp; {{ pageContent?.nextBand?.viaZoomText }}
      </div>
    </div>

    <div class="next-right">
      <div class="countdown"
  aria-label="Countdown to next session"
  role="timer">
        <div class="count-unit" [ngStyle]="ngBoxStyle(pageContent?.nextBand?.countdownBoxStyle)">
    <div class="count-num" [ngStyle]="ngTextStyle(pageContent?.nextBand?.countdownNumberStyle)">{{ countdown.days }}</div>
    <div class="count-lbl" [ngStyle]="ngTextStyle(pageContent?.nextBand?.countdownLabelStyle)">{{ pageContent?.nextBand?.countdownLabels?.days }}</div>
  </div>
  <div class="count-sep" [ngStyle]="ngTextStyle(pageContent?.nextBand?.countdownSeparatorStyle)">:</div>
  <div class="count-unit" [ngStyle]="ngBoxStyle(pageContent?.nextBand?.countdownBoxStyle)">
    <div class="count-num" [ngStyle]="ngTextStyle(pageContent?.nextBand?.countdownNumberStyle)">{{ countdown.hrs }}</div>
    <div class="count-lbl" [ngStyle]="ngTextStyle(pageContent?.nextBand?.countdownLabelStyle)">{{ pageContent?.nextBand?.countdownLabels?.hrs }}</div>
  </div>
  <div class="count-sep" [ngStyle]="ngTextStyle(pageContent?.nextBand?.countdownSeparatorStyle)">:</div>
  <div class="count-unit" [ngStyle]="ngBoxStyle(pageContent?.nextBand?.countdownBoxStyle)">
    <div class="count-num" [ngStyle]="ngTextStyle(pageContent?.nextBand?.countdownNumberStyle)">{{ countdown.mins }}</div>
    <div class="count-lbl" [ngStyle]="ngTextStyle(pageContent?.nextBand?.countdownLabelStyle)">{{ pageContent?.nextBand?.countdownLabels?.mins }}</div>
  </div>
  <div class="count-sep" [ngStyle]="ngTextStyle(pageContent?.nextBand?.countdownSeparatorStyle)">:</div>
  <div class="count-unit" [ngStyle]="ngBoxStyle(pageContent?.nextBand?.countdownBoxStyle)">
    <div class="count-num" [ngStyle]="ngTextStyle(pageContent?.nextBand?.countdownNumberStyle)">{{ countdown.secs }}</div>
    <div class="count-lbl" [ngStyle]="ngTextStyle(pageContent?.nextBand?.countdownLabelStyle)">{{ pageContent?.nextBand?.countdownLabels?.secs }}</div>
  </div>
   <span class="sr-only" aria-live="polite" aria-atomic="true">{{ countdownSummary }}</span>
      </div>

      <button class="btn btn-gold" type="button" (click)="openPopup(nextSession)"
        [ngStyle]="ngButtonStyle(pageContent?.nextBand?.reserveButtonStyle)">
        {{ pageContent?.sessionsSection?.reserveButtonText }}
      </button>
    </div>
  </div>
  <!-- </div> -->
</div>

<section class="sessions-section"
  id="sessions"
  aria-labelledby="sessions-heading"
  [ngStyle]="ngLayoutStyle(pageContent?.sessionsSection?.layoutStyle)">
  <div class="container">
    <div class="sessions-header reveal" [class.visible]="revealSessionsHeader">
      <div class="eyebrow eyebrow-gold" [ngStyle]="ngTextStyle(pageContent?.sessionsSection?.eyebrowStyle)">
        {{ pageContent?.sessionsSection?.eyebrow }}
      </div>

      <h2 id="sessions-heading" [ngStyle]="ngTextStyle(pageContent?.sessionsSection?.headlineStyle)">
        <ng-container *ngFor="let line of sessionsHeadlineLines; let i = index">
          {{ line.before }}
          <ng-container *ngIf="line.em">
            <em [ngStyle]="ngTextStyle(pageContent?.sessionsSection?.headlineEmphasisStyle)">
              {{ line.em }}
            </em>
          </ng-container>
          <ng-container *ngIf="line.after"> {{ line.after }}</ng-container>
          <br *ngIf="i !== sessionsHeadlineLines.length - 1" />
        </ng-container>
      </h2>

      <p [ngStyle]="ngTextStyle(pageContent?.sessionsSection?.paragraphStyle)">
        {{ pageContent?.sessionsSection?.paragraph }}
      </p>
    </div>

    <div class="filter-tabs reveal reveal-delay-1" [class.visible]="revealTabs">
      <button class="filter-tab" [class.active]="activeFilter === 'all'" (click)="setFilter('all')">
        {{ pageContent?.sessionsSection?.allSessionsTabText }}
      </button>
    </div>

    <div class="sessions-grid-duo reveal reveal-delay-2" [class.visible]="revealGrid">

  <ng-container *ngFor="let s of upcomingSessionSlots">

    <!-- Real session card -->
    <ng-container *ngIf="s; else comingSoon">
      <div class="session-card duo-card"
        [class.featured]="isNextUp(s)"
        role="article"
        [attr.aria-label]="'Live coaching session: ' + s.title"
        [attr.data-status]="getSessionStatus(s)"
        [ngStyle]="getSessionCardStyle(s)">
        <div class="session-card-top-bar" [ngStyle]="ngBoxStyle(pageContent?.sessionsSection?.topBarStyle)"></div>
        <div class="session-card-body">
          <span class="session-badge"
            [ngClass]="{ 'badge-next': isNextUp(s), 'badge-upcoming': !isNextUp(s) }"
            [ngStyle]="getSessionBadgeStyle(s)">
            {{ isNextUp(s) ? (pageContent?.sessionsSection?.statusLabels?.nextUp || 'Next Up') : (pageContent?.sessionsSection?.statusLabels?.upcoming || 'Upcoming') }}
          </span>
          <div class="session-date-row">
            <div class="session-date-block" [ngStyle]="ngBoxStyle(pageContent?.sessionsSection?.dateBlockStyle)">
              <div class="month" [ngStyle]="ngTextStyle(pageContent?.sessionsSection?.dateMonthStyle)">{{ formatDateEST(s.sessions?.[0]?.date, 'MMM') }}</div>
              <div class="day" [ngStyle]="ngTextStyle(pageContent?.sessionsSection?.dateDayStyle)">{{ formatDateEST(s.sessions?.[0]?.date, 'DD') }}</div>
            </div>
            <div class="session-time" [ngStyle]="ngTextStyle(pageContent?.sessionsSection?.timeStyle)">
              <strong [ngStyle]="ngTextStyle(pageContent?.sessionsSection?.timeStrongStyle)">{{ formatTimeToEST(s.sessions?.[0]?.startTime || '') }}</strong>
              {{ formatDateEST(s.sessions?.[0]?.date) }}
              &nbsp;·&nbsp; {{ pageContent?.sessionsSection?.viaZoomText }}
            </div>
          </div>
          <div class="session-title"
            [ngStyle]="ngTextStyle(pageContent?.sessionsSection?.titleStyle)"
            itemprop="name">{{ s.title }}</div>
          <div class="session-desc" [ngStyle]="ngTextStyle(pageContent?.sessionsSection?.descriptionStyle)" [innerHTML]="nl2br(s.description)"></div>
          <div class="session-hosts" *ngIf="getHostNamesPreview()">
            <div class="session-host-avatars">
              <ng-container *ngFor="let init of getHostInitialsPreview(); let i = index">
                <div class="host-avatar" [class.gold]="i === 0" [ngStyle]="ngBoxStyle(pageContent?.sessionsSection?.hostAvatarStyle)">{{ init }}</div>
              </ng-container>
            </div>
            <div class="session-host-names" [ngStyle]="ngTextStyle(pageContent?.sessionsSection?.hostNamesStyle)">{{ getHostNamesPreview() }}</div>
          </div>
        </div>
        <div class="session-card-footer">
  <div class="registered" *ngIf="s.alreadyRegistered" [ngStyle]="ngTextStyle(pageContent?.sessionsSection?.registeredTextStyle)">{{ pageContent?.sessionsSection?.registeredText }}</div>

  <ng-container *ngIf="!s.alreadyRegistered">

  <div class="footer-action-row">

    <button
      class="btn footer-reserve-btn"
      [class.btn-gold]="isNextUp(s)"
      [class.btn-outline-navy]="!isNextUp(s)"
      type="button"
      (click)="openPopup(s)"
      [ngStyle]="isNextUp(s)
        ? ngButtonStyle(pageContent?.sessionsSection?.reserveButtonStyle)
        : ngButtonStyle(pageContent?.sessionsSection?.reserveSecondaryButtonStyle)">
      {{ pageContent?.sessionsSection?.reserveButtonText }}
    </button>

    <button class="btn-share-text" type="button" (click)="copySessionLink(s)"
      aria-label="Copy session link" title="Copy link">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <circle cx="18" cy="5" r="3"/>
        <circle cx="6" cy="12" r="3"/>
        <circle cx="18" cy="19" r="3"/>
        <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
        <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
      </svg>
      Share
    </button>

  </div>

</ng-container>
</div>
      </div>
    </ng-container>

    <!-- Coming Soon placeholder -->
    <ng-template #comingSoon>
      <div class="duo-card coming-soon-card">
        <div class="cs-gold-stripe"></div>
        <div class="cs-watermark">SOON</div>
        <div class="cs-body">
          <div class="cs-tag">
            <span class="cs-tag-dot"></span>
            Upcoming Session
          </div>
          <div class="cs-headline-block">
            <span class="cs-word-coming">Coming</span>
            <span class="cs-word-soon">Soon.</span>
          </div>
          <div class="cs-rule"></div>
          <p class="cs-desc">A new session is being scheduled.<br>Check back — new dates are announced regularly.</p>
        </div>
      </div>
    </ng-template>

  </ng-container>

</div>
  </div>
</section>

<section class="expect-section"
  aria-labelledby="expect-heading"
  [ngStyle]="ngLayoutStyle(pageContent?.expectSection?.layoutStyle)">
  <div class="container">
    <div class="expect-header reveal" [class.visible]="revealExpect">
      <div class="eyebrow eyebrow-gold center" [ngStyle]="ngTextStyle(pageContent?.expectSection?.eyebrowStyle)">
        {{ pageContent?.expectSection?.eyebrow }}
      </div>

      <h2 id="expect-heading" [ngStyle]="ngTextStyle(pageContent?.expectSection?.headlineStyle)">
        {{ expectHeadlinePrefix }}
        <em [ngStyle]="ngTextStyle(pageContent?.expectSection?.headlineEmphasisStyle)">
          {{ expectHeadlineEmphasis }}
        </em>
      </h2>

      <div class="divider divider-center"></div>
    </div>

    <div class="expect-grid reveal reveal-delay-1" [class.visible]="revealExpectGrid">
      <div class="expect-card" *ngFor="let c of pageContent?.expectSection?.cards; trackBy: trackByIndex"
        [ngStyle]="ngBoxStyle(c.cardStyle)">
        <div class="expect-num" [ngStyle]="ngTextStyle(c.numStyle)">{{ c.num }}</div>
        <div class="expect-title" [ngStyle]="ngTextStyle(c.titleStyle)">{{ c.title }}</div>
        <div class="expect-body" [ngStyle]="ngTextStyle(c.bodyStyle)">{{ c.body }}</div>
      </div>
    </div>
    <div class="expect-learn-more reveal reveal-delay-2" [class.visible]="revealExpectGrid">
  <a href="https://academy.nexgencoaches.com/icf-overview" target="_blank" rel="noopener noreferrer" class="expect-link">
    Understand the ICF credential pathway in detail →
  </a>
</div>
  </div>
</section>

<section class="hosts-strip"
  aria-labelledby="hosts-heading"
  [ngStyle]="ngLayoutStyle(pageContent?.hostsSection?.layoutStyle)">
  <div class="container">
    <div class="hosts-strip-header reveal" [class.visible]="revealHosts">
      <div class="eyebrow eyebrow-white center" [ngStyle]="ngTextStyle(pageContent?.hostsSection?.eyebrowStyle)">
        {{ pageContent?.hostsSection?.eyebrow }}
      </div>

      <h2 id="hosts-heading" [ngStyle]="ngTextStyle(pageContent?.hostsSection?.headlineStyle)">
        {{ hostsHeadlinePrefix }}
        <em [ngStyle]="ngTextStyle(pageContent?.hostsSection?.headlineEmphasisStyle)">
          {{ hostsHeadlineEmphasis }}
        </em>
      </h2>
    </div>

    <div class="hosts-strip-grid reveal reveal-delay-1" [class.visible]="revealHostsGrid">
      <div class="host-card"
  *ngFor="let h of pageContent?.hostsSection?.hosts; trackBy: trackByIndex"
  itemscope
  itemtype="https://schema.org/Person"
  [ngStyle]="ngBoxStyle(h.cardStyle)">
        <div class="host-avatar-lg" [ngStyle]="ngBoxStyle(h.avatarStyle)">{{ h.initials }}</div>
        <div>
          <div class="host-name" [ngStyle]="ngTextStyle(h.nameStyle)" itemprop="name">{{ h.name }}</div>
          <div class="host-cred" [ngStyle]="ngTextStyle(h.credStyle)" itemprop="jobTitle">{{ h.cred }}</div>
          <div class="host-bio-text" [ngStyle]="ngTextStyle(h.bioStyle)" itemprop="description">{{ h.bio }}</div>
        </div>
      </div>
    </div>
    <div class="hosts-more-link reveal reveal-delay-2" [class.visible]="revealHostsGrid">
  <a href="https://nexgencoaches.com/about-us/"
     class="hosts-about-link"
     rel="noopener">
    Learn more about our faculty →
  </a>
</div>
  </div>
</section>

<section class="final-cta"
  aria-labelledby="cta-heading"
  [ngStyle]="ngLayoutStyle(pageContent?.finalCta?.layoutStyle)">
  <div class="container reveal" [class.visible]="revealCta">
    <div class="eyebrow eyebrow-gold center" [ngStyle]="ngTextStyle(pageContent?.finalCta?.eyebrowStyle)">
      {{ pageContent?.finalCta?.eyebrow }}
    </div>

    <h2 id="cta-heading" [ngStyle]="ngTextStyle(pageContent?.finalCta?.headlineStyle)">
      {{ finalHeadlinePrefix }}
      <em [ngStyle]="ngTextStyle(pageContent?.finalCta?.headlineEmphasisStyle)">
        {{ finalHeadlineEmphasis }}
      </em>
    </h2>

    <p [ngStyle]="ngTextStyle(pageContent?.finalCta?.paragraphStyle)">
      {{ pageContent?.finalCta?.paragraph }}
    </p>

    <div class="final-actions">
      <button class="btn btn-gold" type="button" (click)="nextSession && openPopup(nextSession)"
        [disabled]="!nextSession" [ngStyle]="ngButtonStyle(pageContent?.finalCta?.primaryBtnStyle)">
        {{ pageContent?.finalCta?.primaryBtnText }}
      </button>

      <a class="btn btn-outline-navy"
  [href]="pageContent?.finalCta?.secondaryBtnUrl"
  rel="noopener"
  [ngStyle]="ngButtonStyle(pageContent?.finalCta?.secondaryBtnStyle)">
  {{ pageContent?.finalCta?.secondaryBtnText }}
</a>
    </div>

    <div class="final-note" [ngStyle]="ngTextStyle(pageContent?.finalCta?.noteStyle)">
  {{ pageContent?.finalCta?.note }}
</div>
<div class="seo-internal-links">
  <a href="https://nexgencoaches.com/programs/" class="seo-link">View Programs</a>
  <span class="seo-link-sep">·</span>
  <a href="https://academy.nexgencoaches.com/icf-overview" target="_blank" rel="noopener noreferrer" class="seo-link">ICF Credential Overview</a>
<span class="seo-link-sep">·</span>
<a href="https://academy.nexgencoaches.com/faq" target="_blank" rel="noopener noreferrer" class="seo-link">Common Questions</a>
  <span class="seo-link-sep">·</span>
  <a href="https://nexgencoaches.com/about-us/" class="seo-link">Meet Our Faculty</a>
</div>
  </div>
</section>

<app-bottomside></app-bottomside>

<div class="signup-overlay"
  [class.open]="showPopup"
  (click)="showPopup && closePopup()"
  aria-modal="true"
  role="dialog"
  aria-labelledby="modal-headline"
  [attr.aria-hidden]="showPopup ? null : true">
  <div class="signup-modal" (click)="$event.stopPropagation()"
    [ngStyle]="ngBoxStyle(pageContent?.signupModal?.modalStyle)">
    <div class="modal-top-bar"></div>

    <div class="modal-body">
      <button class="modal-close" type="button" (click)="closePopup()" aria-label="Close">&times;</button>

      <div class="modal-session-meta" [ngStyle]="ngBoxStyle(pageContent?.signupModal?.sessionMetaStyle)">
        <div class="modal-session-label">{{ pageContent?.signupModal?.registeringForLabel }}</div>
        <div class="modal-session-title">{{ selectedSession?.title }}</div>
        <div class="modal-session-date">
  {{ formatDateEST(selectedSession?.sessions?.[0]?.date) }}
  ·
  {{ formatTimeToEST(selectedSession?.sessions?.[0]?.startTime || '', false) }} -
  {{ formatTimeToEST(selectedSession?.sessions?.[0]?.endTime || '') }}
  · {{ pageContent?.miscTexts?.zoomWord }}
</div>
      </div>

      <div *ngIf="modalStep === 'form'">
        <h3 id="modal-headline" [ngStyle]="ngTextStyle(pageContent?.signupModal?.headlineStyle)">
          {{ modalHeadlinePrefix }}
          <em [ngStyle]="ngTextStyle(pageContent?.signupModal?.headlineEmphasisStyle)">
            {{ modalHeadlineEmphasis }}
          </em>
        </h3>

        <p class="modal-sub" [ngStyle]="ngTextStyle(pageContent?.signupModal?.subTextStyle)">
          {{ pageContent?.signupModal?.subText }}
        </p>

        <div class="form-two-col">
          <div class="form-row">
            <label [ngStyle]="ngTextStyle(pageContent?.signupModal?.labelStyle)">
              {{ pageContent?.signupModal?.firstNameLabel }}
            </label>
            <input type="text" [(ngModel)]="firstName" [placeholder]="pageContent?.signupModal?.firstNamePlaceholder"
              [ngStyle]="ngBoxStyle(pageContent?.signupModal?.inputStyle)" />
          </div>

          <div class="form-row">
            <label [ngStyle]="ngTextStyle(pageContent?.signupModal?.labelStyle)">
              {{ pageContent?.signupModal?.lastNameLabel }}
            </label>
            <input type="text" [(ngModel)]="lastName" [placeholder]="pageContent?.signupModal?.lastNamePlaceholder"
              [ngStyle]="ngBoxStyle(pageContent?.signupModal?.inputStyle)" />
          </div>
        </div>

        <div class="form-row">
  <label [ngStyle]="ngTextStyle(pageContent?.signupModal?.labelStyle)">
    {{ pageContent?.signupModal?.emailLabel }}
  </label>

  <input
    type="email"
    [(ngModel)]="email"
    [placeholder]="pageContent?.signupModal?.emailPlaceholder"
    [ngStyle]="ngBoxStyle(pageContent?.signupModal?.inputStyle)"
    (input)="emailError = false"
  />

  <div class="field-error" *ngIf="emailError">
    Please enter a valid email address.
  </div>
</div>

<div class="form-row">
  <label [ngStyle]="ngTextStyle(pageContent?.signupModal?.labelStyle)">
    Human Check
  </label>

  <div class="human-check-wrap">
    <div class="human-check-question">
      {{ humanCheckNum1 }} + {{ humanCheckNum2 }} =
    </div>

    <input
      type="number"
      [(ngModel)]="humanCheckAnswer"
      placeholder="Enter sum"
      [ngStyle]="ngBoxStyle(pageContent?.signupModal?.inputStyle)"
      (input)="humanCheckError = false"
    />
  </div>

  <div class="field-error" *ngIf="humanCheckRequiredError">
    Human Check is required.
  </div>

  <div class="field-error" *ngIf="!humanCheckRequiredError && humanCheckError">
    Please enter the correct sum.
  </div>
</div>
<!-- ────────────────────────────────────────────────────────────────────── -->

<div class="form-row follow-up-row">
  <input
    id="emailFollowUp"
    name="emailFollowUp"
    type="checkbox"
    [(ngModel)]="emailFollowUp"
    class="follow-up-checkbox-native"
  />

  <label
    for="emailFollowUp"
    class="follow-up-label"
    [class.checked]="emailFollowUp"
  >
    <span class="follow-up-box" aria-hidden="true">
      <svg viewBox="0 0 16 16" class="follow-up-check">
        <path d="M3 8.5L6.2 11.5L13 4.8" />
      </svg>
    </span>

    <span class="follow-up-text">
  I’m happy for NEXGEN to follow up by email. I know I can unsubscribe any time. <a href="https://nexgencoaches.com/privacy-policy/" target="_blank" rel="noopener noreferrer" style="color: #f4b921;text-decoration: none;">Privacy Policy</a>.
</span>
  </label>
</div>

<button type="button" class="btn btn-gold form-submit"
  (click)="registerForSession()"
  [disabled]="isSubmitting"
  [ngStyle]="ngButtonStyle(pageContent?.signupModal?.confirmBtnStyle)">
  <span *ngIf="!isSubmitting">{{ pageContent?.signupModal?.confirmBtnText }}</span>
  <span *ngIf="isSubmitting" class="btn-spinner">
    <svg class="spin-icon" width="18" height="18" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3"
        stroke-dasharray="31.4" stroke-dashoffset="10"/>
    </svg>
    Verifying...
  </span>
</button>

        <div class="form-note" [ngStyle]="ngTextStyle(pageContent?.signupModal?.noteStyle)">
          {{ pageContent?.signupModal?.noteText }}
        </div>
      </div>

      <div class="form-success" *ngIf="modalStep === 'success'"
        [ngStyle]="ngBoxStyle(pageContent?.signupModal?.successBoxStyle)">
        <h4 [ngStyle]="ngTextStyle(pageContent?.signupModal?.successHeadlineStyle)">
          {{ successHeadlinePrefix }}
          <em [ngStyle]="ngTextStyle(pageContent?.signupModal?.successHeadlineEmphasisStyle)">
            {{ successHeadlineEmphasis }}
          </em>
        </h4>

        <p [ngStyle]="ngTextStyle(pageContent?.signupModal?.successBodyStyle)">
          {{ pageContent?.signupModal?.successBody }}
        </p>

        <div class="success-mini">
          <div><strong>{{ pageContent?.signupModal?.miniSessionLabel }}</strong> {{ successTitle }}</div>
          <div><strong>{{ pageContent?.signupModal?.miniDateLabel }}</strong> {{ successDate }}</div>
          <div><strong>{{ pageContent?.signupModal?.miniTimeLabel }}</strong> {{ successTime }}</div>
          <div><strong>{{ pageContent?.signupModal?.miniEmailLabel }}</strong> {{ successEmail }}</div>
        </div>

        <button type="button" class="btn btn-outline-navy form-submit" (click)="closePopup()"
          [ngStyle]="ngButtonStyle(pageContent?.signupModal?.closeBtnStyle)">
          {{ pageContent?.signupModal?.closeBtnText }}
        </button>
      </div>
    </div>
  </div>
</div>